import { render, staticRenderFns } from "./BoxesRow.vue?vue&type=template&id=b34e8d66&"
import script from "./BoxesRow.vue?vue&type=script&lang=js&"
export * from "./BoxesRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/toastgroup.no/toastgroup.no/wp-content/themes/toastgroup/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b34e8d66')) {
      api.createRecord('b34e8d66', component.options)
    } else {
      api.reload('b34e8d66', component.options)
    }
    module.hot.accept("./BoxesRow.vue?vue&type=template&id=b34e8d66&", function () {
      api.rerender('b34e8d66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/front/js/compontents/filters/select/BoxesRow.vue"
export default component.exports